import { PortalSettings } from "@edl-development/edl-common";

export class ValidatedRegistrationToken {
    constructor() {
        this.PortalID = null;
        this.PortalName = null;
        this.Token = null;
    }
    PortalSettings: PortalSettings;
    PortalID: string;
    PortalName: string;
    Token: string;
}